module.exports = __webpack_public_path__ + "img/recruit_copy.28a37f25.png";